import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Field } from './Field';

const translateTo = async (translate, text, apply) => {
  try {
    apply(await translate(text));
  } catch (e) {
    alert('Traduzione fallita: ' + e.message);
  }
};

export const AllergensEditor = ({ allergens, onChange, translate }) => {
  const update = (i, patch) => onChange(allergens.map((a, j) => (j === i ? { ...a, ...patch } : a)));
  const remove = (i) => window.confirm('Rimuovere questo allergene dalla legenda?') && onChange(allergens.filter((_, j) => j !== i));
  const add = () => {
    const n = allergens.reduce((m, a) => Math.max(m, Number(a.n) || 0), 0) + 1;
    onChange([...allergens, { n, name: { it: '', en: '' } }]);
  };

  return (
    <section className="bg-white border-[1.5px] border-black rounded-[16px] p-5 md:p-6" data-testid="allergens-editor">
      <div className="flex items-center justify-between mb-1 gap-3">
        <h2 className="font-display text-2xl md:text-3xl text-black">Legenda allergeni</h2>
        <button onClick={add} className="pill-btn text-sm" data-testid="allergen-add-btn"><Plus size={14} /> Aggiungi</button>
      </div>
      <p className="text-xs text-black/60 mb-5">Il numero è quello che selezioni su ogni piatto. Appare in fondo a ogni sezione e nel PDF.</p>
      <ul className="space-y-3">
        {allergens.map((a, i) => (
          <li key={i} className="grid grid-cols-[64px_1fr_auto] md:grid-cols-[64px_1fr_1fr_auto] gap-3 items-end" data-testid={`allergen-row-${i}`}>
            <label className="block row-start-1 col-start-1">
              <span className="block text-[10px] font-bold text-black/50 uppercase tracking-widest mb-1">N°</span>
              <input
                type="number"
                min="1"
                value={a.n}
                onChange={(e) => update(i, { n: Number(e.target.value) })}
                data-testid={`allergen-number-${i}`}
                className="w-full rounded-lg border-[1.5px] border-black/15 bg-white px-3 py-2 focus:outline-none focus:border-black text-sm"
              />
            </label>
            <div className="row-start-1 col-start-2 min-w-0">
              <Field label="Nome IT" value={a.name?.it || ''} onChange={(v) => update(i, { name: { ...a.name, it: v } })} />
            </div>
            <div className="col-span-3 row-start-2 md:col-span-1 md:row-start-1 md:col-start-3 min-w-0">
              <Field
                label="Nome EN"
                value={a.name?.en || ''}
                onChange={(v) => update(i, { name: { ...a.name, en: v } })}
                onTranslate={() => translateTo(translate, a.name?.it || '', (en) => update(i, { name: { ...a.name, en } }))}
                translateDisabled={!a.name?.it}
              />
            </div>
            <button onClick={() => remove(i)} aria-label="Elimina" data-testid={`allergen-delete-${i}`} className="p-2.5 text-red-700 hover:text-red-900 row-start-1 col-start-3 md:col-start-4">
              <Trash2 size={16} />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default AllergensEditor;
